
<div
  v-if="afficherCatfish"
  id="catfish"
  :class="[
    jel_getClassObject(content),
    { 'top-shadow': content.catfishTopShadow, catfish: !mixinEnvironnement_inEditor },
    content.catfishTheme,
  ]"
  :style="{
    '--couleurBackground': content.catfishBackground,
  }"
>
  <!-- :data-start-date="startDate" :data-end-date="endDate" -->
  <div class="d-block" :class="{ 'position-relative': !mixinEnvironnement_inEditor }">
    <span class="catfish-close" @click="fermerCatfish()">x</span>

    <b-link
      v-if="content.typeCatfish.field == 'catfishImage'"
      v-bind="jel_getLienBinding(content.lienCatfish)"
      :ga-img-name="
        $mq == 'xs' || $mq == 'sm'
          ? content.typeCatfish.imageMobile['@name']
          : content.typeCatfish.image['@name']
      "
    >
      <b-img-lazy
        :src="getImage()"
        :alt="content.texte"
        :class="content.typeCatfish.imgStyleFull == 'true' ? 'w-100' : 'mw-100'"
      />
    </b-link>
    <div v-else-if="content.typeCatfish.field == 'catfishHTML'" class="catfish-html">
      <b-link v-bind="jel_getLienBinding(content.lienCatfish)" class="catfish-lien">
        <div class="catfish-texte" v-html="content.typeCatfish.texteHTML" />
      </b-link>
    </div>
  </div>
</div>
